<template>
  <h4 class="pt-2 my-4">
    <span class="text-muted fw-light">
      <router-link :to="{ name: 'admin-courses' }" v-if="educationStore.content.is_admin"
        >Academy</router-link
      >
      <router-link :to="{ name: 'courses' }" v-else>Academy</router-link>
      / </span
    >{{ educationStore.content.title }}
  </h4>
  <div class="card g-3 mt-1" v-if="educationStore.loaded">
    <div class="card-body row g-3">
      <div class="col-lg-8">
        <div
          class="d-flex justify-content-between align-items-center flex-wrap mb-2 gap-1"
        >
          <div class="me-1">
            <h5 class="mb-1" style="font-size: 1.125rem">
              {{ educationStore.content.title }}
            </h5>
            <p class="mb-1">
              Author :
              <span class="fw-medium"> {{ educationStore.content.author_name }}</span>
            </p>
          </div>
          <div class="d-flex align-items-center">
            <span class="badge bg-label-danger">{{
              educationStore.content.category
            }}</span>
            <span
              class="btn btn-outline-primary ml-2"
              @click="openModal('#review-rating')"
              v-if="
                (!educationStore.content.is_admin || !educationStore.content.is_author) &&
                !educationStore.reviewed &&
                userStore.user.id
              "
              >Leave A Review</span
            >
            <span
              class="btn btn-outline-primary ml-2"
              @click="editLecture(educationStore.content.slug)"
              v-if="educationStore.content.is_admin || educationStore.content.is_author"
              >Edit Lecture</span
            >
            <span
              class="btn btn-warning ml-2"
              @click="deleteLecture(educationStore.content.slug)"
              v-if="educationStore.content.is_admin || educationStore.content.is_author"
              >Delete Lecture</span
            >
            <i class="ti ti-bookmarks ti-sm"></i>
          </div>
        </div>
        <div class="card academy-content shadow-none border">
          <div class="p-2">
            <div class="cursor-pointer">
              <video-component
                :poster="educationStore.content.image_url"
                :videoSource="educationStore.video.active_video"
                :videoName="educationStore.video.video_name"
              />
            </div>
          </div>
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <div style="width: 70%">
                <p
                  class="text-primary mb-1"
                  v-if="
                    educationStore.content.is_presell &&
                    !educationStore.content.presell_time_expired
                  "
                >
                  Pre-sell Ends On {{ educationStore.content.presell_expire_at }}
                </p>
                <template v-if="educationStore.video.lesson_desc">
                  <h5 class="mb-2">About this course</h5>
                  <p class="mb-0 pt-1">
                    {{ educationStore.video.lesson_desc }}
                  </p>
                </template>
              </div>
              <div>
                <span
                  class="btn btn-outline-primary ml-2"
                  @click="openModal('#review-rating')"
                  v-if="
                    (!educationStore.content.is_admin ||
                      !educationStore.content.is_author) &&
                    !educationStore.content.has_reviewed &&
                    userStore.user.id
                  "
                  >Leave A Review</span
                >
              </div>
            </div>

            <hr class="my-4" />
            <h5>By the numbers</h5>
            <div class="d-flex flex-wrap">
              <div class="me-5">
                <p class="text-nowrap">
                  <vue-feather type="check" size="15"></vue-feather> Skill level:
                  {{ educationStore.content.skill_level }}
                </p>
                <p class="text-nowrap">
                  <vue-feather type="users" size="15"></vue-feather> Students:
                  {{ educationStore.content.students }}
                </p>
                <p class="text-nowrap">
                  <vue-feather type="flag" size="15"></vue-feather> Languages: English
                </p>
              </div>
              <div>
                <p class="text-nowrap">
                  <vue-feather type="edit-2" size="15"></vue-feather> Lectures:
                  {{ educationStore.content.lecture_count }}
                </p>
                <p class="text-nowrap">
                  <vue-feather type="clock" size="15"></vue-feather> Video:
                  {{ convertSecToTime(educationStore.content.total_watch_hours_string) }}
                </p>
                <p class="text-nowrap">
                  <vue-feather type="star" size="15"></vue-feather>Reviews : ({{
                    formatNumber(educationStore.content.rating_count)
                  }})
                  <star-rating
                    v-model="educationStore.content.avarage_rating"
                    :rating="educationStore.content.avarage_rating"
                    :totalStars="5"
                    :size="18"
                    :disabled="true"
                  />
                </p>
              </div>
            </div>
            <hr class="mb-4 mt-2" />
            <h5>Description</h5>
            <span class="mb-4" v-html="educationStore.content.description"></span>
            <hr class="my-4" />
            <h5>Instructor</h5>
            <div class="d-flex justify-content-start align-items-center user-name">
              <div class="avatar-wrapper">
                <div class="avatar me-2">
                  <img
                    src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos/creditfixrr.jpg"
                    alt="Avatar"
                    class="rounded-circle"
                  />
                </div>
              </div>
              <div class="d-flex flex-column">
                <span class="fw-medium">{{ educationStore.content.author_name }}</span>
                <small class="text-muted">{{ educationStore.content.title }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div
          class="mt-1"
          style="height: 50px"
          v-if="
            (!educationStore.content.is_admin || !educationStore.content.is_author) &&
            educationStore.content.hasPurchased == false
          "
        >
          <template v-if="userStore.user.id">
            <template
              v-if="
                educationStore.content.is_presell &&
                !educationStore.content.presell_time_expired
              "
            >
              <button
                class="btn btn-primary float-right"
                @click="
                  buyCourse(
                    educationStore.content.slug,
                    educationStore.content.presell_price,
                    educationStore.content.is_free,
                    1
                  )
                "
                v-if="!educationStore.content.is_free"
              >
                <vue-feather type="shopping-bag" size="16" class="mr-1"></vue-feather
                >Purchase Now
              </button>
              <button
                class="btn btn-primary float-right"
                @click="
                  buyCourse(
                    educationStore.content.slug,
                    educationStore.content.presell_price,
                    educationStore.content.is_free,
                    1
                  )
                "
                v-else
              >
                <vue-feather type="eye" size="16" class="mr-1"></vue-feather>Watch Now
              </button>
            </template>
            <template v-else-if="userStore.user.has_course_membership">
              <button
                class="btn btn-primary float-right"
                @click="
                  buyCourse(
                    educationStore.content.slug,
                    educationStore.content.price,
                    educationStore.content.is_free,
                    2
                  )
                "
              >
                <vue-feather type="eye" size="16" class="mr-1"></vue-feather>
                Watch Now
              </button>
            </template>
            <template v-else>
              <button
                class="btn btn-primary float-right"
                @click="
                  buyCourse(
                    educationStore.content.slug,
                    educationStore.content.price,
                    educationStore.content.is_free,
                    1
                  )
                "
                v-if="!educationStore.content.is_free"
              >
                <vue-feather type="shopping-bag" size="16" class="mr-1"></vue-feather
                >Purchase Now
              </button>
              <button
                class="btn btn-primary float-right"
                @click="
                  buyCourse(
                    educationStore.content.slug,
                    educationStore.content.price,
                    educationStore.content.is_free,
                    1
                  )
                "
                v-else
              >
                <vue-feather type="eye" size="16" class="mr-1"></vue-feather>Watch Now
              </button>
            </template>
          </template>
          <template v-else>
            <a
              :href="$router.resolve({ name: 'register' }).href"
              class="btn btn-primary float-right"
              >Register</a
            >
          </template>
        </div>
        <div class="accordion stick-top accordion-bordered" id="courseContent">
          <div
            class="accordion-item mb-0 active"
            v-for="(lesson, index) in educationStore.content.lectures"
            :class="{ active: index === 0 }"
            :key="lesson.id"
          >
            <div class="accordion-header" id="headingOne">
              <button
                type="button"
                class="accordion-button bg-lighter rounded-0"
                data-bs-toggle="collapse"
                :data-bs-target="'#chapter' + lesson.id"
                :aria-expanded="index === 0"
                :aria-controls="'chapter' + lesson.id"
              >
                <span class="d-flex flex-column">
                  <span class="h5 mb-1">{{ lesson.title }}</span>
                  <span class="fw-normal text-body"
                    >{{ lesson.watched_videos }} / {{ lesson.lesson_videos.length }} |
                    {{ convertSecToTime(lesson.total_hours) }}
                  </span>
                </span>
              </button>
            </div>
            <div
              :id="'chapter' + lesson.id"
              class="accordion-collapse collapse"
              data-bs-parent="#courseContent"
              :class="{ show: isLastPlayed(lesson) || isActiveVideo(lesson) }"
            >
              <div class="accordion-body py-3 border-top">
                <template
                  v-for="(lesson_video, videoIndex) in lesson.lesson_videos"
                  :key="lesson_video.id"
                >
                  <div
                    class="form-check"
                    :class="{ 'mb-3': videoIndex !== lesson.lesson_videos.length - 1 }"
                  >
                    <div class="d-flex align-items-center">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'defaultCheck' + lesson_video.id"
                        :checked="
                          lesson_video.watched ||
                          educationStore.video.active.slug == lesson_video.slug
                        "
                      />
                      <label
                        :for="'defaultCheck' + lesson_video.id"
                        class="form-check-label ms-3"
                        @click="educationStore.loadVideo(lesson_video.slug)"
                      >
                        <span class="mb-0 h6"
                          >{{ videoIndex + 1 }}. {{ lesson_video.title }}</span
                        >
                        <span class="text-muted d-block">{{
                          convertSecToTime(lesson_video.video_duration)
                        }}</span>
                      </label>
                      <template
                        v-if="
                          !educationStore.content.is_admin ||
                          !educationStore.content.is_author
                        "
                      >
                        <div
                          class="unlock"
                          :class="{
                            active_video:
                              lesson_video.slug === educationStore.video.active.slug,
                          }"
                        >
                          <template v-if="educationStore.content.is_presell">
                            <vue-feather
                              type="play"
                              size="12"
                              class="icon"
                              v-if="lesson_video.is_free || lesson_video.is_preview"
                            ></vue-feather>
                            <vue-feather
                              type="play"
                              size="12"
                              class="icon"
                              v-else-if="
                                (educationStore.content.hasPurchased ||
                                  lesson_video.is_free ||
                                  lesson_video.is_preview) &&
                                educationStore.content.presell_time_expired
                              "
                            ></vue-feather>
                            <vue-feather
                              type="lock"
                              size="12"
                              class="icon"
                              v-else
                            ></vue-feather>
                          </template>
                          <template
                            v-else-if="
                              !userStore.user.has_course_membership &&
                              educationStore.content.user_purchase_type == '2'
                            "
                          >
                            <vue-feather type="lock" size="12" class="icon"></vue-feather>
                          </template>
                          <template v-else>
                            <vue-feather
                              type="play"
                              size="12"
                              class="icon"
                              v-if="
                                educationStore.content.hasPurchased ||
                                lesson_video.is_free ||
                                lesson_video.is_preview
                              "
                            ></vue-feather>
                            <vue-feather
                              type="lock"
                              size="12"
                              class="icon"
                              v-else
                            ></vue-feather>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <div class="unlock">
                          <vue-feather type="play" size="12" class="icon"></vue-feather>
                        </div>
                      </template>
                    </div>
                    <div
                      class="resource-view"
                      v-if="
                        lesson_video.is_preview ||
                        lesson_video.is_free ||
                        (userStore.user.id &&
                          lesson_video.resources &&
                          educationStore.content.hasPurchased)
                      "
                    >
                      <button
                        @click="
                          downloadResource(lesson.id, lesson_video.id, lesson_video.slug)
                        "
                      >
                        <vue-feather
                          type="file-plus"
                          size="24"
                          class="icon"
                        ></vue-feather>
                        Download Resource
                      </button>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <payment-modal :id="'buy-course'" :course-name="course_name">
    <template #header>
      <div class="d-flex">
        <img :src="settingStore.modalLogo" class="mb-2 w-50 mx-auto" alt="creditfixrr" />
      </div>
      <h3 class="text-primary text-center mb-1">
        {{ localizationStore.translate("education.buy.modal.title") }}
      </h3>
      <div v-if="error" class="alert alert-danger mt-1 alert-validation-msg" role="alert">
        <div class="alert-body d-flex align-items-center">
          <vue-feather type="info" size="14" class="mr-50 align-middle top-0" />
          <span v-html="message"></span>
        </div>
      </div>
      <div class="card">
        <div class="card-body d-flex">
          <div style="width: 100px; height: 50px">
            <img
              :src="educationStore.content.image_url"
              class="mx-auto"
              :alt="course_name"
              style="width: 100%"
            />
          </div>
          <div class="ml-1">
            <p class="mb-0">{{ educationStore.content.title }}</p>
            <p class="mb-0" v-if="!educationStore.content.is_free">
              <template
                v-if="
                  educationStore.content.is_presell &&
                  !educationStore.content.presell_time_expired
                "
              >
                ${{ educationStore.content.presell_price }}
              </template>
              <template v-else> ${{ educationStore.content.price }} </template>
            </p>
            <p class="mb-0" v-else>00.00</p>
          </div>
        </div>
      </div>
    </template>
    <template #footer="{ purchaseCourse }">
      <div class="row gy-1 gx-2 mt-75">
        <div class="col-12 text-center">
          <button
            type="button"
            @click="purchaseCourse"
            class="btn btn-primary mr-1 mt-1"
            :key="planStore.paymentBtnKey"
          >
            {{ localizationStore.translate("education.course.buy") }}
          </button>
          <button
            @click="closeModal('#buy-course')"
            type="reset"
            class="btn btn-outline-secondary mt-1"
            aria-label="Close"
          >
            {{ localizationStore.translate("top.up.modal.button.cancel") }}
          </button>
        </div>
      </div>
    </template>
  </payment-modal>
  <review-course-modal :id="'review-rating'"></review-course-modal>
</template>
<script>
import {ref,reactive} from 'vue'
import { closeModal, hideModal, openModal,convertSecToTime,formatNumber,avarage } from '../../../utilities/_helpers'

import { useLocalizationStore } from "../../../stores/LocalizationStore.js";
import { usePlanStore } from "../../../stores/PlanStore.js";
import { useUserStore } from "../../../stores/UserStore.js";
import { useSettingStore } from "../../../stores/SettingStore.js";
import { useEducationStore } from "../../../stores/EducationStore.js";
import PaymentModal from "../../modals/PaymentComponent";
import VideoComponent from "./layouts/VideoComponent.vue";
import ReviewCourseModal from "./layouts/modals/ReviewCourseModal.vue";

export default {
    components: {
        PaymentModal,
        VideoComponent,
        ReviewCourseModal
    },
    setup(){
        return{
            options: { quality: { default: '1080p' } },
            content:reactive({}),
            lesson_desc:ref(),
            video_name:ref(),
            localizationStore:useLocalizationStore(),
            planStore:usePlanStore(),
            settingStore:useSettingStore(),
            userStore:useUserStore(),
            educationStore:useEducationStore(),
            active_video:ref(null),
            course_name:ref(null),
            loaded:ref(false),
            lastWatched:reactive({}),
            openModal:openModal,
            closeModal:closeModal,
            convertSecToTime:convertSecToTime,
            formatNumber:formatNumber,
            avarage,avarage,
            purchase_type:ref(0),
            _: _,
        }
    },
    mounted() {
        this.educationStore.getCourseContent();
    },
    watch: {
        courseWatch:{
            deep: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    this.content.hasPurchased = newVal
                    // Check if the new video source is not empty
                }
            },
        },
        watchLessonSelectd:{
            deep: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    const lessonToUpdate = _.find(this.content.lessons, { id: newVal.lesson_id });
                    if (lessonToUpdate) {
                        lessonToUpdate.watched_videos = newVal.watched_videos;
                    }
                }
            },
        },
        rating:{
            deep: true,
            handler(newVal, oldVal) {
                if (newVal) {
                    this.educationStore.avarage_rating = this.avarage(newVal.total,newVal.count);
                }
            },
        }
    },
    created() {
        if (this.$route.name == 'courses-content') {
            const link = document.createElement('link')
            link.rel = 'stylesheet'
            link.type = 'text/css'
            link.href = '/css/education.css'
            document.head.appendChild(link)
        }
    },
    destroyed() {
        document.documentElement.classList.remove('core-css-class')

        const existingLink = document.querySelector('link[href="/css/education.css"]')
        if (existingLink) {
            existingLink.parentNode.removeChild(existingLink)
        }
    },
    computed: {
        courseWatch() {
            return this.userStore.course;
        },
        watchLessonSelectd(){
            return this.educationStore.video.active;
        },
        rating(){
            return this.educationStore.rating;
        }
    },
    methods:{
        buyCourse(slug,cost,is_free,purchase_type){
            this.course_name = slug
            cost = parseInt(cost);
            cost = Math.round(cost);

            if(is_free || this.userStore.user.has_course_membership || cost <= 0){
                let $this = this;
                const route = this.$router.resolve({
                    name:'purchase-free-course',
                });
                let payload={
                    purchase_type:purchase_type
                }
                axios.post(
                    route.href,
                    payload
                ).then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    window.location.reload()
                    return
                }).catch(function(error) {
                    setTimeout(() => {
                        toastr.error(error.response.data.response_msg, 'Error!');
                    }, 2000)
                });
            }else{
                this.openModal('#buy-course');
                this.planStore.purchase_type = purchase_type
            }

        },
        editLecture(slug){
            this.$router.push({name:'course-edit',
                params:{
                    course:slug
                }
            });
        },
        deleteLecture(slug){
            let $this = this;
            const route = this.$router.resolve({
                name:'course-delete',
                params:{
                    course : slug
                }
            });
            Swal.fire({
                title: 'Are you sure you want to this Course?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes Delete!',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1'
                },
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    axios.post(route.href)
                    .then(function (response) {
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        toastr.success(response.data.message, 'Success!');
                        $this.$router.push({name:'courses'});
                        return
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            });
        },
        isLastPlayed(lesson) {
            return (
              this.educationStore.last_played !== null &&
              typeof this.educationStore.last_played !== 'undefined' &&
              this.educationStore.last_played.lesson_id === lesson.id
            );
        },
        isActiveVideo(lesson) {
            return this.educationStore.video.active.lesson_id === lesson.id;
        },
        async downloadResource(lesson_id,video_id,video_title){
            let $this = this;
            if($this.userStore.user.id){
                const route = this.$router.resolve({
                    name:'lesson-download-resource',
                    params:{
                        lesson : lesson_id,
                        video : video_id
                    }
                }).href;
                try{
                    const response = await axios.get(route, {
                        responseType: 'blob',
                    });
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);

                    let link = document.createElement('a');
                    link.href = url;
                    link.download = video_title+'.pdf'
                    link.click();
                    window.URL.revokeObjectURL(url)
                }catch(e){
                    console.error('Failed to download PDF:', e);
                }
            }

        }
    }
};
</script>
<style scoped>
.active_video {
  background: #4b9a5e !important;
  color: white;
}
.unlock {
  height: 24px;
  width: 24px;
  background: #d0d0d0;
  border-radius: 50%;
  position: absolute;
  right: 0px;
}
.unlock .icon {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
}
.resource-view {
  height: 30px;
  width: 100%;
  position: relative;
}
.resource-view button {
  position: absolute;
  border: 1px solid #dee2df;
  right: 0px;
  height: 32px;
  font-size: 14px;
  color: #4b9a5e;
  background: white;
}
</style>
